import { render, staticRenderFns } from "./PopupNewComponentTypeForm.vue?vue&type=template&id=56e05f36"
import script from "./PopupNewComponentTypeForm.vue?vue&type=script&lang=js"
export * from "./PopupNewComponentTypeForm.vue?vue&type=script&lang=js"
import style0 from "./PopupNewComponentTypeForm.vue?vue&type=style&index=0&id=56e05f36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports